var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-fullscreen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "w100" },
        [
          _vm.$wf.isMdUp
            ? _c(
                "w-breadcrumb",
                [
                  _c("w-tabs", {
                    staticClass: "light",
                    attrs: { tabs: _vm.tabs },
                    model: {
                      value: _vm.activeTab,
                      callback: function ($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab",
                    },
                  }),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel mr",
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                  ),
                  _c("w-button", { on: { click: _vm.save } }, [
                    _vm._v(" " + _vm._s(_vm.$t("common.save")) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.currentTabKey == "general"
            ? _c(
                "w-scroll-view",
                { attrs: { tag: "w-container" } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(_vm._s(_vm.$ct("identification"))),
                              ]),
                              _c(
                                "w-card-content",
                                [
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "12" } },
                                        [
                                          _c("w-input", {
                                            attrs: {
                                              label: _vm.$ct(
                                                "labels.custom-label"
                                              ),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.CustomLabel,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "CustomLabel",
                                                  $$v
                                                )
                                              },
                                              expression: "car.CustomLabel",
                                            },
                                          }),
                                          _c("w-input", {
                                            attrs: {
                                              label: _vm.$ct("labels.brand"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Brand,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Brand", $$v)
                                              },
                                              expression: "car.Brand",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.type"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Type,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Type", $$v)
                                              },
                                              expression: "car.Type",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.chassis"),
                                              "max-length": 17,
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Chassis,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "Chassis",
                                                  $$v
                                                )
                                              },
                                              expression: "car.Chassis",
                                            },
                                          }),
                                          _c("w-date-picker", {
                                            staticClass: "mts",
                                            style: { flexGrow: "1" },
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct(
                                                "labels.construction"
                                              ),
                                            },
                                            model: {
                                              value: _vm.car.ConstructionYear,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "ConstructionYear",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "car.ConstructionYear",
                                            },
                                          }),
                                          _c("w-input-number", {
                                            staticClass: "mts",
                                            attrs: {
                                              decimals: 0,
                                              label: _vm.$ct("labels.mileage"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Mileage,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "Mileage",
                                                  $$v
                                                )
                                              },
                                              expression: "car.Mileage",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.engine"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Engine,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Engine", $$v)
                                              },
                                              expression: "car.Engine",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.tyres"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Tyres,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Tyres", $$v)
                                              },
                                              expression: "car.Tyres",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.power"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Power,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Power", $$v)
                                              },
                                              expression: "car.Power",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.cilinder"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Cilinder,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "Cilinder",
                                                  $$v
                                                )
                                              },
                                              expression: "car.Cilinder",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.co2"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Co2,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Co2", $$v)
                                              },
                                              expression: "car.Co2",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct(
                                                "labels.transmission"
                                              ),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Transmission,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "Transmission",
                                                  $$v
                                                )
                                              },
                                              expression: "car.Transmission",
                                            },
                                          }),
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.fuel"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Fuel,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Fuel", $$v)
                                              },
                                              expression: "car.Fuel",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(_vm._s(_vm.$ct("more"))),
                              ]),
                              _c(
                                "w-card-content",
                                [
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("app-contact-search", {
                                            attrs: {
                                              label: _vm.$ct("labels.contact"),
                                              fancy: "",
                                              value: _vm.car.Contact,
                                              "group-id": 1,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.selectContact($event)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("app-contact-search", {
                                            attrs: {
                                              label: _vm.$ct("labels.supplier"),
                                              fancy: "",
                                              value: _vm.car.Supplier,
                                              "group-id": 2,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.selectSupplier(
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [_c("w-col", [_c("w-divider")], 1)],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-date-picker", {
                                            style: { flexGrow: "1" },
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct(
                                                "labels.purchase-date"
                                              ),
                                            },
                                            model: {
                                              value: _vm.car.PurchaseDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "PurchaseDate",
                                                  $$v
                                                )
                                              },
                                              expression: "car.PurchaseDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("app-purchase-search", {
                                            attrs: {
                                              label: _vm.$ct("labels.purchase"),
                                              fancy: "",
                                              value: _vm.car.Purchase,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.selectPurchase(
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [_c("w-col", [_c("w-divider")], 1)],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-date-picker", {
                                            style: { flexGrow: "1" },
                                            attrs: {
                                              fancy: "",
                                              label: _vm.$ct(
                                                "labels.invoice-date"
                                              ),
                                            },
                                            model: {
                                              value: _vm.car.InvoiceDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "InvoiceDate",
                                                  $$v
                                                )
                                              },
                                              expression: "car.InvoiceDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("app-sale-search", {
                                            attrs: {
                                              label: _vm.$ct("labels.invoice"),
                                              fancy: "",
                                              value: _vm.car.Invoice,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.selectSale($event)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [_c("w-col", [_c("w-divider")], 1)],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            attrs: {
                                              label: _vm.$ct("labels.plate"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Plate,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Plate", $$v)
                                              },
                                              expression: "car.Plate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-date-picker", {
                                            style: { flexGrow: "1" },
                                            attrs: {
                                              fancy: "",
                                              nullable: "",
                                              label:
                                                _vm.$ct("labels.comm-date"),
                                            },
                                            model: {
                                              value: _vm.car.CommDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "CommDate",
                                                  $$v
                                                )
                                              },
                                              expression: "car.CommDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct("labels.keycode"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.KeyCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "KeyCode",
                                                  $$v
                                                )
                                              },
                                              expression: "car.KeyCode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label:
                                                _vm.$ct("labels.radiocode"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.RadioCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "RadioCode",
                                                  $$v
                                                )
                                              },
                                              expression: "car.RadioCode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct(
                                                "labels.exterior-color"
                                              ),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.ExteriorColor,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "ExteriorColor",
                                                  $$v
                                                )
                                              },
                                              expression: "car.ExteriorColor",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-col",
                                        { attrs: { xs: "12", md: "6" } },
                                        [
                                          _c("w-input", {
                                            staticClass: "mts",
                                            attrs: {
                                              label: _vm.$ct(
                                                "labels.interior-color"
                                              ),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.InteriorColor,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "InteriorColor",
                                                  $$v
                                                )
                                              },
                                              expression: "car.InteriorColor",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        [
                                          _c("w-textarea-autogrow", {
                                            attrs: {
                                              label: _vm.$ct("labels.info"),
                                              fancy: "",
                                            },
                                            model: {
                                              value: _vm.car.Info,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.car, "Info", $$v)
                                              },
                                              expression: "car.Info",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-row",
                                    [
                                      _c(
                                        "w-col",
                                        [
                                          _c("w-checkbox", {
                                            attrs: {
                                              disabled:
                                                !_vm.hasCarpassConfigured,
                                              label: _vm.$ct("use-in-carpass"),
                                            },
                                            model: {
                                              value: _vm.car.UseInCarpass,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.car,
                                                  "UseInCarpass",
                                                  $$v
                                                )
                                              },
                                              expression: "car.UseInCarpass",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.currentTabKey == "files"
            ? _c(
                "w-scroll-view",
                { attrs: { tag: "w-container" } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-car-aws-documents", {
                            attrs: { car: _vm.car },
                            on: {
                              upload: function ($event) {
                                return _vm.uploadAwsDocuments()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c("w-col", { attrs: { xs: "12", md: "6" } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.currentTabKey == "extra-fields"
            ? _c(
                "w-scroll-view",
                { attrs: { tag: "w-container" } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-card",
                            [
                              _c("w-card-title", [
                                _vm._v(_vm._s(_vm.$ct("extra-fields"))),
                              ]),
                              _c(
                                "w-card-content",
                                [
                                  _c("app-extra-fields-edit", {
                                    attrs: {
                                      "name-settings": _vm.extraFieldSettings,
                                      "tab-id": "",
                                    },
                                    model: {
                                      value: _vm.car.ExtraFields,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.car, "ExtraFields", $$v)
                                      },
                                      expression: "car.ExtraFields",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("w-col", { attrs: { xs: "12" } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeTab >= _vm.defaultTabs.length
            ? _c(
                "w-scroll-view",
                { attrs: { tag: "w-container" } },
                [
                  _c("app-extra-field-tab", {
                    key: "extra-field-" + _vm.activeTab,
                    attrs: {
                      value: _vm.car.ExtraFields,
                      tab: _vm.extraFieldTabs[
                        _vm.activeTab - _vm.defaultTabs.length
                      ],
                      "name-settings": _vm.extraFieldSettings,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }